/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Main_LabelInputs */

const en_nav_main_label = /** @type {(inputs: Nav_Main_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Main navigation`)
};

const lv_nav_main_label = /** @type {(inputs: Nav_Main_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Galvenā navigācija`)
};

/**
* | output |
* | --- |
* | "Main navigation" |
*
* @param {Nav_Main_LabelInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const nav_main_label = /** @type {((inputs?: Nav_Main_LabelInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Main_LabelInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_nav_main_label(inputs)
	return en_nav_main_label(inputs)
});